export default {
  product: {
    name: 'Buy gift card',
  },
  description: {
    items: {
      delivery: 'Immediately sent by email as a PDF',
      usage: {
        online: 'Redeemable online only',
        online_and_store: 'Redeemable online and in the restaurant',
      },
      value: 'Flexible amounts from {{from}} to {{to}}',
    },
  },
};
